import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/styles/index.css'; // Ensure this path is correct
import Main from '@/components/App'; // Change this to import Main instead of App
import reportWebVitals from '@/reportWebVitals'; // Ensure this path is correct
import 'bootstrap/dist/css/bootstrap.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//<React.StrictMode>
_jsx(Main, {}) // Use Main instead of App
//</React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
